import { LinearProgress, LinearProgressProps } from '@mui/material'
import React from 'react'

const LinearProgressWrapper: React.FC<LinearProgressProps> = ({ ...props }) => <LinearProgress {...props} />

export default LinearProgressWrapper
